module.exports = __webpack_public_path__ + "img/pet.67f0eb3b.png";